import { setLocalStorage } from './set-local-storage';

export type GetLocalStorageConfig = {
  /** Whether fallback value should be set in storage if no value is present @default false. */
  setOnFallback?: boolean;
}

/**
 * Get @see key from @see localStorage and parse it into an object.
 *
 * @note If no value is found @see fallback can return a default value.
 */
export function getLocalStorage<T>(
  key: string,
  fallback: () => T,
  config?: GetLocalStorageConfig
): T;
export function getLocalStorage<T>(
  key: string,
  fallback?: () => T,
  config?: GetLocalStorageConfig
): T | null;
export function getLocalStorage<T>(
  key: string,
  fallback?: () => T,
  {
    setOnFallback = false
  }: GetLocalStorageConfig = {}
): T | null {
  const stringValue = localStorage.getItem(key)?.trim();
  if (stringValue) {
    return JSON.parse(stringValue);
  } else if (typeof fallback === 'function') {
    const value = fallback();
    return (setOnFallback) ? setLocalStorage(key, value) : value;
  }

  return null;
}
